import { styled } from "@mui/styles";

export const FillShiftCard = styled("div")(() => ({
  borderRadius: "8px",
  background: "#F9FAFB",
  width: "100%",
  minHeight: "216px",
  padding: "12px",

  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
}));
